import { render, staticRenderFns } from "./index_original.vue?vue&type=template&id=9b32e640&scoped=true"
import script from "./index_original.vue?vue&type=script&lang=js"
export * from "./index_original.vue?vue&type=script&lang=js"
import style0 from "./index_original.vue?vue&type=style&index=0&id=9b32e640&lang=sass"
import style1 from "./index_original.vue?vue&type=style&index=1&id=9b32e640&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b32e640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b32e640')) {
      api.createRecord('9b32e640', component.options)
    } else {
      api.reload('9b32e640', component.options)
    }
    module.hot.accept("./index_original.vue?vue&type=template&id=9b32e640&scoped=true", function () {
      api.rerender('9b32e640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/index_original.vue"
export default component.exports